










import { Vue, Component, Watch } from 'vue-property-decorator'
import HeaderComponent from './layout/header.vue'
import FooterComponent from './layout/footer.vue'

@Component({
  components: {
    HeaderComponent,
    FooterComponent
  }
})
export default class AppComponent extends Vue {
  @Watch('$i18n.locale', { immediate: true })
  public syncronizeTitleWithLocale () {
    document.title = this.$t('global.page.title') as string
  }
}
